import React from "react";
import { Box, Typography } from "@mui/material";

type BlockedPackageNoticeProps = {
  shipperName: string;
};

const BlockedPackageNotice: React.FC<BlockedPackageNoticeProps> = ({ shipperName }) => {
  return (
    <Box
      id="blocked-package-notice"
      sx={{
        border: "1px solid #ede0a8",
        borderRadius: 1,
        backgroundColor: "#fbf3d3",
        px: 3,
        py: 2,
        mb: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography
        variant="body1"
        sx={{ color: "#6b5e2a", textAlign: "center" }}
      >
        Delivery notes can't be added for this package here. Please reach out to {shipperName} to share your delivery instructions.
      </Typography>
    </Box>
  );
};

export default BlockedPackageNotice;
